<template>
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15" height="18" viewBox="0 0 15 18">
    <defs>
        <clipPath id="clip-Arrow">
        <rect width="15" height="18"/>
        </clipPath>
    </defs>
    <g id="Arrow" clip-path="url(#clip-Arrow)">
        <g id="noun_Arrow_1787131" transform="translate(4.966 4)">
        <g id="Groupe_3068" data-name="Groupe 3068" transform="translate(0 10.569) rotate(-90)">
            <path id="Tracé_3220" data-name="Tracé 3220" d="M5.318,5.283a.481.481,0,0,0,.289-.12L10.41.84A.482.482,0,0,0,9.765.124L5.285,4.157.8.124A.482.482,0,0,0,.16.84l4.8,4.322a.481.481,0,0,0,.356.12Z" :fill="color" :stroke="color" stroke-width="0.5"/>
        </g>
        </g>
    </g>
    </svg>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'ChevronRight',
    mixins: [Colorable],
};
</script>

